import { Pipe } from '@angular/core';
import { every } from '../utils/utils';
var EveryPipe = (function () {
    function EveryPipe() {
    }
    EveryPipe.prototype.transform = function (input, predicate) {
        return every(input, predicate);
    };
    return EveryPipe;
}());
export { EveryPipe };
EveryPipe.decorators = [
    { type: Pipe, args: [{
                name: 'every'
            },] },
];
/** @nocollapse */
EveryPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=every.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/every.pipe.js
// module id = 232
// module chunks = 103